export default __webpack_public_path__ + "static/media/methi_powder.18ac39bd.png";